<script lang="ts">
  import { onMount } from "svelte"
  import { PUBLIC_HASH } from "$env/static/public"
  import { encryptJson } from "$lib/utils/encryption"
  import userStore, { userStoreActions } from "$lib/stores/userStore"
  import { Label } from "$lib/components/ui/label"
  import { Input } from "$lib/components/ui/input"
  import { Button } from "$lib/components/ui/button"
  import { updateCompetitionEntry } from "$lib/components/Widget2/utils"

  interface Props {
    action: any
    competition: any
    hasMoreVerificationsAfter?: boolean
  }

  let {
    action,
    competition,
    hasMoreVerificationsAfter = false,
  }: Props = $props()

  let value = $state("")
  let verification = action?.actions?.verification[0]
  let ThumbmarkJS: any

  onMount(async () => {
    try {
      await import(
        "https://cdn.jsdelivr.net/npm/@thumbmarkjs/thumbmarkjs/dist/thumbmark.umd.js"
      )
      ThumbmarkJS = (window as any).ThumbmarkJS
    } catch (error) {
      console.error("Error loading ThumbmarkJS:", error)
    }
  })

  async function submitVerification() {
    const fingerprint = ThumbmarkJS ? await ThumbmarkJS.getFingerprint() : null
    const fingerprintData = ThumbmarkJS
      ? await ThumbmarkJS.getFingerprintData()
      : null

    const { encrypted, iv } = await encryptJson(fingerprintData, PUBLIC_HASH)

    updateCompetitionEntry(
      $userStore.user,
      competition,
      action,
      {
        [verification.name]: value,
      },
      fingerprint,
      encrypted,
    )
    userStoreActions.setUser({
      ...$userStore.user,
      completedActions: [
        ...$userStore.user.completedActions,
        {
          action_id: action.id,
          status: { reason: null, status: "valid" },
          verification_data: { [verification.name]: value },
        },
      ],
    })
    userStoreActions.setOpenActionId(null)
    userStoreActions.removeActionNeedingVerification(action.id)
  }
</script>

<div class="space-y-2 mb-4 px-4 pt-2 pb-0">
  <Label for="{verification.name}-{action.id}" class="mb-4">
    What is your {verification.name}?
  </Label>
  <Input
    type={verification.type === "String" ? "text" : "number"}
    id="{verification.name}-{action.id}"
    placeholder={verification.placeholder}
    bind:value
    min={verification.type === "String" ? undefined : 1}
  />
  <Button class="w-full mt-2" onclick={submitVerification} disabled={!value}>
    Continue
  </Button>
</div>
